import isBlankFromPackage from 'is-blank';

export default function isBlank(object) {
  if (object === true || object === false || object === 0) {
    return false;
  }
  return isBlankFromPackage(object);
};